import { Component, OnInit, Input, OnDestroy, ChangeDetectorRef, OnChanges } from '@angular/core';
import { MeteringPoint, Information } from '@model';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { PageType } from '@enums';
import { Store } from '@ngrx/store';
import * as fromStore from '@core/store';
import * as fromProductsStore from '@appStore/products';
import * as fromMeteringPointStore from '@appStore/metering-points';
import { map } from 'rxjs/operators';
import { environment } from '@environment';
import { SubSink } from 'subsink';
import { MatSelectChange } from '@angular/material/select';
import { MeteringPointFunctionControl } from 'app/models/metering-point-function-control';

@Component({
    selector: 'app-metering-point-function-control-pane',
    templateUrl: './metering-point-function-control-pane.component.html',
    standalone: false
})
export class MeteringPointFunctionControlPaneComponent implements OnInit, OnChanges, OnDestroy {
  @Input()
  meteringPoint: MeteringPoint;

  information$: Observable<Information>;
  isProductAvailable = false;
  private subs = new SubSink();

  containedHasFunctionControls = false;
  selectedMeteringPoint: MeteringPoint;
  functionControls: MeteringPointFunctionControl[];

 // functionControls: Observable<void>;

  constructor(private router: Router,
    private informationStore: Store<fromStore.InformationState>,
    private changeDetectorRef: ChangeDetectorRef,
    private meteringPointStore: Store<fromMeteringPointStore.State>,
    private productsStore: Store<fromProductsStore.State>) {}

  ngOnInit() {

    this.containedHasFunctionControls = this.meteringPoint?.containedMeteringPoints.some(meteringPoint => meteringPoint.hasFunctionControl); 
  
    if (this.meteringPoint.type !== 'LOG') {
      this.selectedMeteringPoint = this.meteringPoint;
    }

    this.information$ = this.informationStore
      .select(fromStore.getInformation)
      .pipe(
        map(infos =>
          infos?.informations.find(
            info =>
              info.key !== null &&
              info.key.toLowerCase() ===
                (this.meteringPoint.hasFunctionControl || this.containedHasFunctionControls
                  ? PageType.MeteringPointDetailsHaveFunctionProtocol.toLowerCase()
                  : PageType.MeteringPointDetailsDontHaveFunctionProtocol.toLowerCase())
          )
        )
      );

      this.subs.sink = this.productsStore.select(fromProductsStore.getAllProducts).subscribe((productCategories) => {
        if (productCategories) {
          productCategories.forEach(productCategory => {
            let fcProducts = productCategory.products.filter(
              product => product.productNumber === environment.functionControlProductCode
            );
            if (fcProducts && fcProducts.length > 0) {
              this.isProductAvailable = true;
            }
          });
        }
      });


      if (this.meteringPoint.type === 'LOG' && this.containedHasFunctionControls) {

            this.selectedMeteringPoint = this.meteringPoint.containedMeteringPoints[0];
      }
  }

  ngOnChanges() {
      if (!this.meteringPoint) {
        return;
      }
  
      if (this.meteringPoint.type !== 'LOG' && this.meteringPoint.functionControlsLoaded && this.meteringPoint.functionControls) {
        this.selectedMeteringPoint = this.meteringPoint;
        this.functionControls = this.meteringPoint.functionControls.map(x => ({
          ...x
        }));
    
        this.changeDetectorRef.detectChanges();

      } else if (
        this.meteringPoint.type === 'LOG' &&
        this.containedHasFunctionControls &&
        this.selectedMeteringPoint &&
        this.selectedMeteringPoint.functionControlsLoaded
      ) {
        this.functionControls = this.selectedMeteringPoint.functionControls.map(x => ({
          ...x
        }));

        this.changeDetectorRef.detectChanges();
      }
  }

  subMeteringPointChanged = (event: MatSelectChange) => {
   
      this.selectedMeteringPoint = this.meteringPoint.containedMeteringPoints.find(x => x.id === event.value);
  
      if (this.selectedMeteringPoint.hasFunctionControl && 
          !this.selectedMeteringPoint.functionControlsLoaded && 
          !this.selectedMeteringPoint.functionControlsLoading) {
            this.meteringPointStore.dispatch(
                  new fromMeteringPointStore.LoadMeteringPointFunctionControls({
                    masterMeteringPointId: this.meteringPoint.id,
                    meteringPointId: this.selectedMeteringPoint.id
              })
          );
        } 

      if (this.selectedMeteringPoint.hasFunctionControl && 
          !this.selectedMeteringPoint.functionControlContractLoaded && 
          !this.selectedMeteringPoint.functionControlContractLoading) {
            this.meteringPointStore.dispatch(
                  new fromMeteringPointStore.LoadMeteringPointFunctionControlContract({
                    masterMeteringPointId: this.meteringPoint.id,
                    meteringPointId: this.selectedMeteringPoint.id
              })
          );
      } 


      this.changeDetectorRef.detectChanges();
  };

  goToOrder = () => {
    this.router.navigate([`/secure/products/functioncontrol/${this.meteringPoint.id}`]);
  };

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
